<template>
	<div
		class="g-block-title-trail-line g-block-title-padding"
		:class="{
			'g-block-title-trail-line--edit': editable,
			'is-active': editable && active,
			'g-block-title-trail-line--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-trail-line__row">
			<RichTextEditable
				v-if="editable"
				class="g-block-title-trail-line__text"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.content"
				placeholder="请输入标题"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-trail-line__text"
				:style="{ color: themeColor }"
				v-html="data.content || ''"
			></div>
			<span class="g-block-title-trail-line__trail" :style="{ background: lightColor }"></span>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleTrailLine',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-trail-line {
		.title-block-edit-shell();
	}

	.g-block-title-trail-line__row {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.g-block-title-trail-line__text {
		flex-shrink: 0;
		font-size: 20px;
		font-weight: 700;
		line-height: 1.3;
		:deep(.g-rich-text-editable__content) { min-height: unset; padding: 0; font-weight: 700; }
	}

	.g-block-title-trail-line__trail {
		flex: 1;
		height: 1px;
		min-width: 24px;
	}

	.g-block-title-trail-line--h5 {
		.g-block-title-trail-line__row { gap: 0.24rem; }
		.g-block-title-trail-line__text { font-size: 0.4rem; }
		.g-block-title-trail-line__trail { height: 0.02rem; }
	}
</style>
